/**
 * Balus Logger
 * (http://pimterry.github.io/loglevel/)
 *
 *  - debug('debug message')
 *  - info('information log')
 *  - error('error log')
 *
 * @type {*}
 */
const LogLevel = require('loglevel');
LogLevel.setLevel('debug');

module.exports = LogLevel;



// WEBPACK FOOTER //
// ./common/util/logger.js